import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Grid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { ThemeSwitch } from '@helpers/theme';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import TabButtonStyles from '@stories/Components/Buttons/TabButton/TabButton.styles';
import { DocumentCardStyles } from '@stories/Components/Cards/DocumentCard/DocumentCard.styles';
import { WYSIWYGStyles } from '@stories/Components/Content/WYSIWYG/WYSIWYG.styles';
import SelectStyles from '@stories/Components/Forms/Select/Select.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled, { css } from 'styled-components';
const Container = styled.section `
  padding: 20px 0px;
`;
const ContentGrid = styled(Grid.Default) `
  grid-row-gap: 20px;

  @media ${from(Device.MobileLarge)} {
    grid-row-gap: 30px;
  }

  @media ${from(Device.Tablet)} {
    grid-row-gap: 40px;
  }

  @media ${from(Device.TabletLarge)} {
    grid-row-gap: 50px;
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;

  grid-column: span 12;
  order: 0;

  @media ${from(Device.Tablet)} {
    grid-column: span 9;
  }

  ${ButtonStyles.Button} {
    width: fit-content;
    margin-right: auto;

    ${ButtonStyles.Inner} {
      padding: 0;
    }
  }
`;
const ContentSection = styled.div `
  ${WYSIWYGStyles.Wrapper} {
    overflow: unset;

    li {
      ${ParagraphStyles.RegularStyles};
      margin-bottom: 5px;
      padding-left: 26px;
      position: relative;
      ${ThemeSwitch({ groundforceColour: brand.primary.base })}

      &:before {
        content: '';
        display: block;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        background-color: var(--theme);
        position: absolute;
        top: 0.5em;
        left: 0px;
      }
    }
  }
`;
const Filters = styled.div `
  grid-column: span 12;
  display: flex;
  gap: 15px;
  order: 2;
  overflow-x: auto;

  @media ${until(Device.MobileLarge)} {
    &::-webkit-scrollbar {
      width: 0;
    }
  }

  @media ${from(Device.TabletLarge)} {
    gap: 25px;
  }

  ${SelectStyles.Wrapper}, ${SelectStyles.Element} {
    @media ${until(Device.MobileLarge)} {
      width: 100%;
    }
  }

  ${TabButtonStyles.Button} {
    min-width: max-content;
  }

  ${({ fromDevice }) => {
    if (!fromDevice) {
        return;
    }
    return css `
      display: none;

      @media ${from(fromDevice)} {
        display: flex;
      }
    `;
}}

  ${({ untilDevice }) => {
    if (!untilDevice) {
        return;
    }
    return css `
      display: none;

      @media ${until(untilDevice)} {
        display: flex;
      }
    `;
}}
`;
const FiltersLoadMoreWrapper = styled.div `
  width: 100%;
`;
const FiltersLoadMore = styled.button.attrs({ type: 'button' }) `
  ${ButtonReset};
  font-size: 18px;
  ${ThemeSwitch({ groundforceColour: brand.primary.dark })}
  color: var(--theme);
  ${fonts.DaxPro.Bold};
`;
const Search = styled.div `
  grid-column: span 12;
`;
const SearchWrapper = styled.div `
  position: relative;

  @media ${from(Device.MobileLarge)} {
    display: inline-block;
    width: 300px;
  }

  svg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: ${brand.grey.grey20};
    width: 25px;
    height: 21px;

    @media ${from(Device.Tablet)} {
      width: 32px;
      height: 27px;
    }
  }
`;
const Searchbox = styled.input `
  padding: 16px 40px 16px 0px;
  border: none;
  outline: none;
  background: ${brand.white};
  border-bottom: 1px solid ${brand.grey.grey20};
  color: ${brand.grey.grey20};
  font-size: 18px;
  ${fonts.DaxPro.Regular};
  width: 100%;

  @media ${from(Device.MobileLarge)} {
    padding: 16px 50px 20px 0px;
  }
`;
const Results = styled(Grid.Inner) `
  grid-column: span 12;
  @media ${from(Device.TabletLarge)} {
    grid-column: span 9;
  }

  order: 4;

  ${DocumentCardStyles.Card} {
    grid-column: span 12;
    @media ${from(Device.MobileLarge)} {
      grid-column: span 6;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: span 4;
    }
  }
`;
const ResultsFooter = styled.div `
  grid-column: span 12;
  text-align: center;
  margin-bottom: 30px;
  order: 5;
`;
const ResultGrid = styled.div `
  grid-column: span 12;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 24px;
  border-top: 2px solid ${brand.grey.grey89};

  @media ${until(Device.TabletLarge)} {
    gap: 12px;
    border-top: none;
  }
`;
const FilterWrapper = styled.div `
  position: relative;

  @media ${until(Device.TabletLarge)} {
    padding: 16px 0 0;
    grid-column: span 12;
    position: sticky;
    top: 0;
    z-index: 3;
  }

  @media ${from(Device.TabletLarge)} {
    position: relative;
    grid-column: span 3;
    grid-row: span 2;
    z-index: 2;
  }
`;
const NoResultsMsg = styled.div `
  grid-column: span 12;
  padding-top: 30px;

  @media ${from(Device.TabletLarge)} {
    text-align: center;
  }
`;
const ProductListingStyles = {
    Container,
    ContentGrid,
    ContentSection,
    ContentWrapper,
    Filters,
    FiltersLoadMoreWrapper,
    FiltersLoadMore,
    FilterWrapper,
    NoResultsMsg,
    Search,
    SearchWrapper,
    Searchbox,
    ResultGrid,
    Results,
    ResultsFooter,
};
export default ProductListingStyles;
